/* eslint-disable no-restricted-imports */

import { all, AllEffect } from 'redux-saga/effects';

import { appSagas } from 'app/app.sagas';
import { conversationsBulkModalSagas } from 'app/components/appModals/components/conversationsBulkModal/conversationsBulkModal.sagas';
import { profileSagas } from 'app/views/layout/views/settings/views/profile/settingsProfile.sagas';
import { conversation as conversationSagas } from 'components/conversation/sagas/conversation';
import { conversations as conversationsSagas } from 'components/conversation/sagas/conversations';
import { elevio as elevioSagas } from 'components/conversation/sagas/elevio';
import { feedback as feedbackSagas } from 'components/conversation/sagas/feedback';
import { originalEmail as originalEmailSagas } from 'components/conversation/sagas/originalEmail';
import { satisfaction as satisfactionSagas } from 'components/conversation/sagas/satisfaction';
import { timeline as timelineSagas } from 'components/conversation/sagas/timeline';
import { notifications as notificationsSagas } from 'components/notifications/sagas/notification';
import {
  holdMusic as holdMusicSagas,
  waitMusic as waitMusicSagas,
} from 'components/powerCallFlow/components/modals/utils/shared/sagas/waitHoldMusic';
import { callFlow as callFlowSagas } from 'components/powerCallFlow/sagas/callFlow';
import { callFlows as callFlowsSagas } from 'components/powerCallFlow/sagas/callFlows';
import { flowLanguages as flowLanguagesSagas } from 'components/powerCallFlow/sagas/flowLanguages';
import { chatFlow as chatFlowSagas } from 'components/powerChatFlow/sagas/chatFlow';
import { chatFlows as chatFlowsSagas } from 'components/powerChatFlow/sagas/chatFlows';
import { emailFlow as emailFlowSagas } from 'components/powerEmailFlow/sagas/emailFlow';
import { presence as presenceSagas } from 'components/presence/sagas/presence';
import { organization as organizationV2Sagas } from 'components/settings/organization/sagas/organization';
import { chatWidgets as chatWidgetsSagas } from 'components/settings/sagas/chatWidgets';
import { email as emailSagas } from 'components/settings/sagas/email';
import { organization as organizationSagas } from 'components/settings/sagas/organization';
import { personal as personalSagas } from 'components/settings/sagas/personal';
import { queues as queuesSagas } from 'components/settings/sagas/queues';
import { satisfaction as satisfactionSettingsSagas } from 'components/settings/sagas/satisfaction';
import { telephony as telephonySagas } from 'components/settings/sagas/telephony';
import { templates as templatesSagas } from 'components/settings/sagas/templates';
import { addCaller as addCallerSagas } from 'components/shared/addCallerModal/sagas/addCaller';
import { audioSagas as audioSagasSagas } from 'components/shared/audio/sagas/audio';
import { companyModalSagas as companyModalSagasSagas } from 'components/shared/companyModal/sagas/companyModal';
import { composeEmail as composeEmailSagas } from 'components/shared/composeEmail/sagas/composeEmail';
import { transferToAgentModal as transferToAgentModalSagas } from 'components/shared/transferToAgentModal/sagas/transferToAgent';
import { transferToNumberModal as transferToNumberModalSagas } from 'components/shared/transferToNumberModal/sagas/transferToNumber';
import { transferToQueueModal as transferToQueueModalSagas } from 'components/shared/transferToQueueModal/sagas/transferToQueueModal';
import { telephonySagas as telephonySagasSagas } from 'components/telephony/sagas/telephony';
import { userModalSagas } from 'components/usersModal';
import { electronSagas } from 'middleware/electron';
import { jabraSagas } from 'middleware/jabra';
import { twilio as twilioSagas } from 'middleware/twilio/sagas/twilio';
import { visibility as visibilitySagas } from 'middleware/visibility/sagas/visibility';
import { websocket as websocketSagas } from 'middleware/websocket/sagas/websocket';

/** The application sagas. */
export function* sagas(): Generator<AllEffect<unknown>> {
  yield all([
    ...conversationsBulkModalSagas,
    ...addCallerSagas,
    ...appSagas,
    ...audioSagasSagas,
    ...callFlowSagas,
    ...callFlowsSagas,
    ...chatFlowSagas,
    ...chatFlowsSagas,
    ...chatWidgetsSagas,
    ...companyModalSagasSagas,
    ...composeEmailSagas,
    ...conversationSagas,
    ...conversationsSagas,
    ...electronSagas,
    ...elevioSagas,
    ...emailFlowSagas,
    ...emailSagas,
    ...feedbackSagas,
    ...flowLanguagesSagas,
    ...holdMusicSagas,
    ...jabraSagas,
    ...notificationsSagas,
    ...organizationSagas,
    ...organizationV2Sagas,
    ...originalEmailSagas,
    ...personalSagas,
    ...presenceSagas,
    ...profileSagas,
    ...queuesSagas,
    ...satisfactionSagas,
    ...satisfactionSettingsSagas,
    ...telephonySagas,
    ...telephonySagasSagas,
    ...templatesSagas,
    ...timelineSagas,
    ...transferToAgentModalSagas,
    ...transferToNumberModalSagas,
    ...transferToQueueModalSagas,
    ...twilioSagas,
    ...userModalSagas,
    ...waitMusicSagas,
    ...websocketSagas,
    ...visibilitySagas,
  ]);
}
